import { FormattedMessage } from 'react-intl';

import { ASSISTANTS } from 'utils/constants/assistant-steps';
import { LIST_ITEM_TEXT_LENGTH } from 'utils/constants/misc';
import { ROUTE_ASSISTANT } from 'utils/constants/routes';
import shortenString from 'utils/misc/shorten-string';
import SidebarCard from '../SidebarCard';
import SidebarItem from '../SidebarItem';
import SidebarItemContent from '../SidebarItemContent';
import SidebarItemHeader from '../SidebarItemHeader';
import SidebarMarker from '../SidebarMarker';
import { SidebarItemProps } from './item-types';

export const SidebarPainpointDescription = ({
  session,
  showHeader
}: SidebarItemProps) => {
  if (!session?.painpoint_description) {
    if (showHeader) {
      return (
        <SidebarMarker type="painpoint_description">
          <SidebarItem>
            <SidebarItemHeader>
              <FormattedMessage id="assistant sidebar painpoint" />
            </SidebarItemHeader>
          </SidebarItem>
        </SidebarMarker>
      );
    }

    return <SidebarMarker type="painpoint_description" />;
  }

  return (
    <SidebarMarker type="painpoint_description">
      <SidebarItem>
        <SidebarItemHeader date={session.painpoint_description_date}>
          <FormattedMessage id="assistant sidebar painpoint" />
        </SidebarItemHeader>

        <SidebarItemContent>
          <SidebarCard
            to={{
              pathname:
                ROUTE_ASSISTANT +
                '/' +
                session.id +
                ASSISTANTS.creative_session.step1_2.route,
              state: {
                canGoBack: true
              }
            }}
            header={<FormattedMessage id="Painpoint" />}
            text={shortenString(
              session.painpoint_description,
              LIST_ITEM_TEXT_LENGTH
            )}
          />
        </SidebarItemContent>
      </SidebarItem>
    </SidebarMarker>
  );
};

export default SidebarPainpointDescription;
